import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { TariffServiceConfigSchema } from '../configurations/TariffServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderTariffDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.TARIFF]: TariffServiceConfigSchema,
    }),
});

export { servicesProviderTariffDataSchema };
//# sourceMappingURL=ServicesProviderTariffData.js.map
